import type { ReactNode } from 'react';

import type { BaseIcon } from '../Icons/BaseIcon';

export enum TagVariant {
  WHITE = 'background',
  LIGHT_GREY = 'backgroundPage',
  DARK_GREY = 'iconSecondary',
  GREY = 'textHelper',
  BLACK = 'textPrimary',
  YELLOW = 'backgroundWarning',
  RED = 'backgroundDanger',
  GREEN = 'backgroundSuccess',
  BLUE = 'backgroundInformation',
  LIGHT_PURPLE = 'backgroundAccent',
  PURPLE = 'textAccent',
  GENAI = 'genAiTagBackground',
  TRANSPARENT = 'transparent',
}

export type TagSize = 'regular' | 'small';

interface BaseProps {
  className?: string;
  variant?: TagVariant;
  size?: TagSize;
  textDataTestId?: string;
  textClassName?: string;
}

interface NoTextTagProps extends BaseProps {
  Icon: typeof BaseIcon;
  children?: never;
  LeftIcon?: never;
  RightIcon?: never;
}

interface WithTextTagProps extends BaseProps {
  LeftIcon?: typeof BaseIcon;
  RightIcon?: typeof BaseIcon;
  children: ReactNode;
  Icon?: never;
}

export type TagProps = NoTextTagProps | WithTextTagProps;
